import React from "react";

/** Small controlled presentational piece shared by every print document's address-override
 *  section (InvoicePusat/InvoiceCabang/SuratJalanPusat/SuratJalanCabang) — a label + textarea
 *  + a required-blank hint. State/validation/save-on-Cetak logic lives in each document
 *  component, not here; this is deliberately dumb. */
export default function AddressOverrideField({ label, value, onChange, rows = 2 }) {
  const blank = !value.trim();
  return (
    <div className="form-row">
      <label className="form-label">{label}</label>
      <textarea
        className="form-input"
        rows={rows}
        value={value}
        onChange={(e) => onChange(e.target.value)}
      />
      {blank && (
        <div className="form-hint" style={{ color: "var(--red)" }}>
          Wajib diisi — alamat tidak boleh kosong untuk mencetak.
        </div>
      )}
    </div>
  );
}
